import type { BaseResponse } from '@/utils/request';
import { request } from '@/utils/request';

/* 获取登录用户新 */
export function getInfo() {
  return request<API.AdminUserInfo>({
    url: '/newapi/user/users/getUserInfo',
    method: 'post',
  });
}

export function updateAccountInfo(data: any) {
  return request<BaseResponse<any>>(
    {
      url: '/account/update',
      method: 'post',
      data,
    },
    {
      notificationType: 'all',
    },
  );
}

/* 修改密码 */
export function updatePassword(data: {
  newPassword: string
  oldPassword: string
}) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/users/editPassword',
    method: 'post',
    data,
  }, {
    notificationType: 'all',
  });
}

export function permmenu() {
  return request<API.PermMenu>({
    url: '/account/permmenu',
    method: 'get',
  });
}

/* 修改昵称/QQ等信息 */
export function resetAccountInfo(data: {
  nickName?: string
  qq?: string
}) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/users/setUserInfo',
    method: 'post',
    data,
  }, {
    notificationType: 'all',
  });
}

/* 修改手机号 */
export function resetAccountMobile(data: {
  msgCode: string
  newMobile: string
  newMobileType: number
  newmsgCode: string
}) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/users/editMobile',
    method: 'post',
    data,
  }, {
    notificationType: 'all',
    successMsg: '绑定手机号成功，请重新登录！',
  });
}

/* 修改邮箱 */
export function resetAccountEmail(data: {
  email: string
  emailMsgCode: string
  msgCode: string
}) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/users/setEmail',
    method: 'post',
    data,
  }, {
    notificationType: 'all',
  });
}

/* 注销账号 */
export function deleteAccount(data: {
  password: string
  code: string
}) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/users/cancellation',
    method: 'post',
    data,
  }, {
    notificationType: 'all',
    successMsg: '账号已注销，即将退出登录',
  });
}

/* 修改用户头像 */
export function resetAccountIcon(data: { imgURL: string }) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/users/setImg',
    method: 'post',
    data,
  }, {
    notificationType: 'all',
  });
}

/* 获取收藏地址列表 */
export function getShippingAddressList() {
  return request<API.ShippingAddressItem[]>({
    url: '/newapi/user/userCollectionAddress/getMyCollectionAddress',
    method: 'post',
    data: {
      isDefault: 0,
    },
  });
}

/* 添加收藏地址 */
export function addShippingAddress(data: Record<string, any>) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/userCollectionAddress/collectAddress',
    method: 'post',
    data,
  }, {
    notificationType: 'all',
    successMsg: '添加成功',
  });
}

/* 修改收藏地址 */
export function updateShippingAddress(data: Record<string, any>) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/userCollectionAddress/editCollectionAddress',
    method: 'post',
    data,
  }, {
    notificationType: 'all',
    successMsg: '修改成功',
  });
}

/* 删除收藏地址 */
export function deleteShippingAddress(data: { id: number }) {
  return request<BaseResponse<any>>({
    url: '/newapi/user/userCollectionAddress/deleteCollectionAddress',
    method: 'post',
    data,
  }, {
    notificationType: 'all',
    successMsg: '删除成功',
  });
}

